<ng-container *transloco="let t">
<ng-template #addressTemplate let-stepComponent="this">
  <address [address]="address"></address>

  @if (isRefinance) {
    <refi-options [subjectProperty]="mortgage.subjectProperty"
      [fieldsToConfig]="step.fieldConfig">
    </refi-options>
  }

  <!--
    Admin field-config editor — rendered only on the Property Address Refi step
    instance so refi-only toggles don't clutter the purchase / current address
    admin UIs. AddressStep.hasCustomFieldConfigEditor=true suppresses the
    auto-renderer in wizard-step-template for every AddressStep instance.
  -->
  @if (inEditMode && step.path === propertyAddressRefiPath) {
    <div class="fv-row mb-2">
      <field-config-editor [fieldConfigs]="step.getFieldsToConfig(step.fieldConfig)"
        [header]="t('wizard.refi.fieldConfigHeader')"></field-config-editor>
    </div>
  }
</ng-template>

<wizard-step-template [stepMainTemplate]="addressTemplate" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
